'use client';

import { Box, Stack } from '@mantine/core';
import { Bets } from '../Bets';
import { Brands } from '../Brands';
import { GamesCard } from '../Shares/GamesCard';
import { games } from '../Shares/games';
import { BigWin } from '../WinLastes';
import { CasinoBanner } from './CasinoBanner';
import { CasinoCategory } from './CasinoCategory';
import { CasinoSearch } from './CasinoSearch';
import { CasinoThemeCard } from './CasinoThemeCard';
export const Casino: React.FC = () => {
  const tops = games.find(item => item.id === 'tops');
  const primes = games.find(item => item.id === 'primes');
  const slots = games.find(item => item.id === 'slots');
  const releases = games.find(item => item.id === 'new-releases');
  const blackJack = games.find(item => item.id === 'black-jack');
  const battles = games.find(item => item.id === 'battles');
  const gameShow = games.find(item => item.id === 'game-show');
  return <>
      <CasinoBanner />
      <BigWin />
      <Stack my={{
      base: 36,
      sm: 40
    }} justify="center" align="center">
        <Box w={{
        base: '100%',
        sm: '90%'
      }}>
          <CasinoSearch />
        </Box>
      </Stack>
      <CasinoCategory />
      <GamesCard id={tops?.id || ''} title={tops?.title} items={tops?.items || []} />
      <GamesCard id={slots?.id || ''} title={slots?.title} items={slots?.items || []} />
      <GamesCard id={primes?.id || ''} title={primes?.title} items={primes?.items || []} />
      <Brands />
      <GamesCard id={releases?.id || ''} title={releases?.title} items={releases?.items || []} />
      <GamesCard id={blackJack?.id || ''} title={blackJack?.title} items={blackJack?.items || []} />
      <CasinoThemeCard />
      <GamesCard id={battles?.id || ''} title={battles?.title} items={battles?.items || []} />
      <GamesCard id={gameShow?.id || ''} title={gameShow?.title} items={gameShow?.items || []} />
      <Bets hasActionTab />
    </>;
};